import actionTypes from '../constants/action-types';

const setPaymentURL = (url) => ({
  type: actionTypes.SET_PAYMENT_URL,
  payload: { url },
});

export default setPaymentURL;
